import axios from 'axios';

export const chat = async (param) => 
    await axios.post(
        `/api/${localStorage.getItem('entityId')}/chat`,
        JSON.stringify(param),
        {
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        }
    );